import React from 'react';
export function EngagementsSection() {
  return <section id="engagements" className="py-24 md:py-32 border-t border-gray-100 max-w-6xl mx-auto px-6" data-id="element-23">
      <div className="mb-20" data-id="element-24">
        <h2 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-25">
          Engagements
        </h2>
        <h3 className="text-3xl md:text-4xl font-light text-black mb-4" data-id="element-26">
          Short-term. Embedded. Outcome-driven.
        </h3>
        <p className="text-xl text-gray-600 font-light" data-id="element-27">
          I step in when progress is at risk—either from too much motion without
          clarity, or too much thinking without action.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16" data-id="element-28">
        <div className="flex flex-col" data-id="element-29">
          <h4 className="text-xl font-medium text-black mb-6 pb-2 border-b border-gray-200 inline-block" data-id="element-30">
            Structure
          </h4>
          <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-31">
            I embed quickly and work alongside you. I remove what's slowing
            execution in real time.
          </p>
          <ul className="space-y-3 mt-auto" data-id="element-32">
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-33">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-34"></span>
              Weekly leadership syncs
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-35">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-36"></span>
              Clear ownership and decision rights
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-37">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-38"></span>
              Tight feedback loops
            </li>
          </ul>
        </div>

        <div className="flex flex-col" data-id="element-39">
          <h4 className="text-xl font-medium text-black mb-6 pb-2 border-b border-gray-200 inline-block" data-id="element-40">
            Timeline
          </h4>
          <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-41">
            I come in, build the execution layer, and step out. This work is
            designed to be temporary.
          </p>
          <ul className="space-y-3 mt-auto" data-id="element-42">
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-43">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-44"></span>
              8-10 week sprints
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-45">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-46"></span>
              Milestone-based scope
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-47">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-48"></span>
              Clear definition of "done"
            </li>
          </ul>
        </div>

        <div className="flex flex-col" data-id="element-49">
          <h4 className="text-xl font-medium text-black mb-6 pb-2 border-b border-gray-200 inline-block" data-id="element-50">
            Model
          </h4>
          <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-51">
            I start small and earn trust. If momentum isn't real, I stop.
          </p>
          <ul className="space-y-3 mt-auto" data-id="element-52">
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-53">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-54"></span>
              30-day mutual trial
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-55">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-56"></span>
              Monthly retainer
            </li>
            <li className="text-gray-500 text-sm uppercase tracking-wide flex items-center" data-id="element-57">
              <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-3" data-id="element-58"></span>
              Scope adjusted weekly based on impact
            </li>
          </ul>
        </div>
      </div>
    </section>;
}